import { useEffect, useState } from 'react';

function getOnlineStatus() {
  return typeof navigator !== 'undefined' ? navigator.onLine : true;
}

export function useOnlineStatus() {
  const [isOnline, setOnline] = useState(getOnlineStatus());
  function goOnline() {
    setOnline(true);
  }
  function goOffline() {
    setOnline(false);
  }
  useEffect(() => {
    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);
    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  return isOnline;
}
